import React from "react";
import { Link } from "react-router-dom";
import { Col, Container, NavLink, Row } from "reactstrap";
import "./Cta.css"

const Cta = () => {
  return (
    <React.Fragment>
      <div className="section-sm bg-cta" id="industries">
        <div className="color-overlay"></div>

        <Container>
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="heading-box text-white text-center">
                <h3 className="heading-title mb-4">
                  Industries We Serve
                </h3>
                <div className="industry-badge-wrapper d-flex flex-wrap justify-content-center gap-3">
                  <span className="industry-badge">Automotive</span>
                  <span className="industry-badge">Electronics</span>
                  <span className="industry-badge">Textile & Printing</span>
                  <span className="industry-badge">Packaging</span>
                  <span className="industry-badge">Pharma</span>
                  <span className="industry-badge">FMCG</span>
                  <span className="industry-badge">Manufacturing</span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Cta;
